<template>
  <div class="Index">
    <md-card md-with-hover v-for="imageFile in imageFileList" v-bind:key="imageFile.id">
      <md-ripple>
        <md-card-media>
          <img v-lazy="imageFile.src" alt="" @click="selectApps(imageFile.id)">
        </md-card-media>
        <md-card-header>
          <h2 class="md-title" @click="selectApps(imageFile.id)">{{imageFile.title}}</h2>
        </md-card-header>
        <md-card-content>
        <span @click="selectApps(imageFile.id)">{{imageFile.description}}</span>
        </md-card-content>
      </md-ripple>
    </md-card>
  </div>
</template>
<script>
export default {
  name: 'Index',
  data () {
    return {
      imageFileList: []
    }
  },
  created: function () {
    for (var id = 1; id <= this.getMaxApps(); id++) {
      var items = {}
      items.id = id
      items.src = require('@/assets/apps/Apps_' + items.id + '_optimized.png')
      items.title = this.getAppsInfo(id).title
      items.description = this.getAppsInfo(id).description
      items.audioSrc = this.getAppsInfo(id).audioSrc
      this.imageFileList.push(items)
    }
    // 画面タイトルを設定する(default)
    this.$emit('setTitle')
    this.$emit('setFooterVisible', false)
  },
  methods: {
    selectApps: function (selectNo) {
      this.debug('selectApps(' + selectNo + ')')
      this.playAudio(this.getAppsInfo(selectNo).audioSrc)
      this.$emit('setTitle', this.getAppsInfo(selectNo).title)
      // 特定の画像を選択
      this.$router.push({name: this.getAppsInfo(selectNo).link})
    },
    onClearCanvas: function () {
      this.debug('何もしない')
    },
    nextCanvas: function () {
      this.debug('何もしない')
    },
    beforeCanvas: function () {
      this.debug('何もしない')
    }
  }
}
</script>
<style lang="scss" scoped>
  .contents {
    width: 100%;
    margin-bottom: 80px;
    background-color: white;
    z-index:  1;
  }
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue